import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LoadMyGamesCommandHandler } from '../handlers';

export const loadMyGamesResolver: ResolveFn<void> = () => {
  inject(LoadMyGamesCommandHandler).load().subscribe();
};
